/**
 * Suppress all console output except in development on localhost
 * This prevents console warnings and errors from showing in production
 */

// Deliver resize callbacks on the next frame. Chrome otherwise reports
// "ResizeObserver loop completed with undelivered notifications" and the
// dev error screen treats that notice as a crash.
if (typeof window.ResizeObserver === 'function' && !window.ResizeObserver.__quiet) {
  const NativeResizeObserver = window.ResizeObserver;
  function QuietResizeObserver(callback) {
    let frame = 0;
    let queued = [];
    let queuedObserver = null;
    const inner = new NativeResizeObserver((entries, observer) => {
      queued = entries;
      queuedObserver = observer;
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        callback(queued, queuedObserver);
      });
    });
    this.observe = (target, options) => inner.observe(target, options);
    this.unobserve = (target) => inner.unobserve(target);
    this.disconnect = () => {
      if (frame) {
        window.cancelAnimationFrame(frame);
        frame = 0;
      }
      inner.disconnect();
    };
  }
  QuietResizeObserver.prototype = NativeResizeObserver.prototype;
  QuietResizeObserver.__quiet = true;
  window.ResizeObserver = QuietResizeObserver;
}

const isResizeObserverNotice = (value) => String(value || '').includes('ResizeObserver loop');

window.addEventListener('error', (event) => {
  const fromEvent = event && event.message;
  const fromError = event && event.error && event.error.message;
  if (isResizeObserverNotice(fromEvent) || isResizeObserverNotice(fromError)) {
    event.stopImmediatePropagation();
  }
}, true);

const isProduction = process.env.NODE_ENV === 'production';
const isDevelopmentHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Only suppress in production OR if explicitly set
if (isProduction || !isDevelopmentHost) {
  // Override console methods with empty functions
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.info = () => {};
}

// Suppress specific React and browser warnings
if (typeof window !== 'undefined') {
  // Override console.warn
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const message = String(args[0] || '');
    
    // Filter out specific warnings
    if (
      message.includes('Password field is not contained') ||
      message.includes('[DOM] Password field') ||
      message.includes('findDOMNode') ||
      message.includes('componentWillReceiveProps') ||
      message.includes('componentWillMount')
    ) {
      return;
    }
    
    // Call original warn for other messages (unless fully suppressed)
    if (!isProduction && isDevelopmentHost) {
      originalWarn.apply(console, args);
    }
  };

  // Also suppress console.error for specific messages
  const originalError = console.error;
  console.error = (...args) => {
    const message = String(args[0] || '');
    
    // Filter out fetch errors for expected 404s
    if (
      message.includes('Password field is not contained') ||
      message.includes('[DOM] Password field')
    ) {
      return;
    }
    
    // Call original error for other messages (unless fully suppressed)
    if (!isProduction && isDevelopmentHost) {
      originalError.apply(console, args);
    }
  };
}

const suppressConsole = {};
export default suppressConsole;
